export const buttons = [
					{
						to: "/",
						iconName: "home",
						name: "Home"
					},
					{
						to: "/skills",
						iconName: "js square",
						name: "Skills"
					},
					{
						to: "/projects",
						iconName: "code",
						name: "Projects"
					},
					{
						to: "/coursework",
						iconName: "book",
						name: "Coursework"
					},
					{
						to: "/about",
						iconName: "info circle",
						name: "About Me"
					},
					{
						to: "/contact",
						iconName: "send",
						name: "Contact"
					}
				];